import { Avatar, IconButton } from "@mui/material";
import React from "react";
import { CiSearch } from "react-icons/ci";
import { IoMdArrowDropdown } from "react-icons/io";
import { PiFlowerTulip } from "react-icons/pi";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

const translatedRoles = {
  SuperAdmin: "Administrador",
  EcosystemEditor: "Editor de ecosistema",
  StoreEditor: "Editor de tienda",
};

const elements = [
  {
    title: "Registro de laboratorio",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/registroLaboratorio",
  },
  {
    title: "Panel Detallado",
    allowedUsers: ["SuperAdmin"],
    path: "/home/panel",
  },
  {
    title: "Registro de consumo",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/registroConsumo",
  },
  {
    title: "Lista de medicina",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/listaMedicina",
  },
  {
    title: "Temporadas",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/temporadas",
  },
  {
    title: "Registro de bloques",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/registroBloques",
  },
  {
    title: "Clasificación de productos",
    allowedUsers: ["StoreEditor", "SuperAdmin"],
    path: "/home/productos",
  },
  {
    title: "Inventario de productos",
    allowedUsers: ["StoreEditor", "SuperAdmin"],
    path: "/home/inventario",
  },
  {
    title: "Compras de clientes",
    allowedUsers: ["StoreEditor", "SuperAdmin"],
    path: "/home/purchases",
  },
  {
    title: "Blog de tienda",
    allowedUsers: ["EcosystemEditor", "SuperAdmin"],
    path: "/home/blogs",
  },
  {
    title: "Tutoriales",
    allowedUsers: ["StoreEditor", "SuperAdmin"],
    path: "/home/tutoriales",
  },
  {
    title: "Banners y Posts",
    allowedUsers: ["SuperAdmin, StoreEditor"],
    path: "/home/bannersAndPosts",
  },
  {
    title: "Administrar usuarios",
    allowedUsers: ["SuperAdmin"],
    path: "/home/users",
  },
];

const NavDrawerElements = ({ user, handleLogout, closeDrawer }) => {
  const navigate = useNavigate();
  return (
    <>
      {/*user section */}
      <div className=" p-4 py-2 flex flex justify-between items-center">
        <div className="flex flex-row items-center gap-2">
          <IconButton
            sx={{
              width: 40,
              height: 40,
              //background: (theme) => alpha(theme.palette.grey[500], 0.08),
            }}
          >
            <Avatar
              src={
                user?.profileImage?.url
                  ? process.env.REACT_APP_SERVER + user.profileImage.url
                  : null
              }
              alt={"Perfil"}
              sx={{
                width: 36,
                height: 36,
                border: (theme) =>
                  `solid 2px ${theme.palette.background.default}`,
              }}
            >
              {user.name.charAt(0).toUpperCase()}
            </Avatar>
            <IoMdArrowDropdown />
          </IconButton>
          <div className="flex flex-col justify-start items-start">
            <span className="font-poppins font-bold">{user.name}</span>
            <span className="font-poppins text-xs text-average-gray">
              {translatedRoles[user.role]}
            </span>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="hover:bg-red-200 rounded-[2px] p-[2px]"
        >
          <TbLogout2 className="m-0 h-[20px] w-[20px]" />
        </button>
      </div>
      {/*search section */}
      {/* <div className="w-full relative flex items-center justify-center px-4">
        <input
          type="text"
          className="rounded-full font-nunito w-full placeholder-opacity-50 placeholder-dark-green text-dark-green text-accent-green bg-light-green border border-accent-green px-10"
          placeholder="Search"
        />
        <CiSearch className="absolute top-1/2 left-7 opacity-50 transform -translate-y-1/2 text-dark-green" />
      </div> */}
      {/*section with elements */}
      <ul className="flex flex-col gap-y-1 m-2 mt-4">
        {elements.map((element, i) => {
          if (element.allowedUsers.includes(user.role)) {
            return (
              <li
                key={i}
                className="flex rounded-full items-center flex-row gap-x-2 py-2 px-4 hover:bg-light-green  text-dark-green font-poppins cursor-pointer"
                onClick={() => {
                  closeDrawer();
                  navigate(element.path);
                }}
              >
                <PiFlowerTulip />
                <span className="">{element.title}</span>
              </li>
            );
          }
        })}
      </ul>
    </>
  );
};

export default NavDrawerElements;
